import forEach from 'lodash/forEach';
import memoizeOne from 'memoize-one';
import type { ProjectId } from '../../../../model/app';
import type { ItemProject, ItemTypes, ItemType } from '../../../../model/table';

type ItemTypeLookup = {
	[itemTypeId: string]: ItemType;
};

export const getProjectById = memoizeOne(
	(projects: ItemProject[], projectId: ProjectId): ItemProject =>
		projects.find(({ id }) => id === projectId) || projects[0],
);

export const getItemTypesByProjectId = (projects: ItemProject[], projectId: ProjectId): ItemTypes =>
	getProjectById(projects, projectId).itemTypes;

export const getProjectItemTypeForLevel = (
	projects: ItemProject[],
	projectId: ProjectId,
	level: number,
): ItemType => getItemTypesByProjectId(projects, projectId)[level][0];

export const getItemTypesLookupByProject = memoizeOne(
	(projects: ItemProject[], projectId: ProjectId): ItemTypeLookup => {
		const itemTypes = getItemTypesByProjectId(projects, projectId);
		const lookup: ItemTypeLookup = {};

		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		forEach(itemTypes as ItemTypes, (itemTypesPerLevel: ItemType[]) => {
			itemTypesPerLevel.forEach((itemTypePerLevel: ItemType) => {
				lookup[`${itemTypePerLevel.id}`] = itemTypePerLevel;
			});
		});

		return lookup;
	},
);
